export default __webpack_public_path__ + "static/media/Konspekt 1.88bdce57.pdf";